import QuestionAnswerCard from "./QuestionAnswerCard";

export default QuestionAnswerCard;
